import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loading } from '@/components/loaders';
import { Button } from '@/lib';
import { SmsCampaign } from '../Sms/Campaigns/Create/SmsCampaign';
import { useSmsWorkspaceTemplates } from '../Sms/context/SmsWorkspaceContext';
import { RouteConstants } from '@/features/router/RouteConstants';

export const CampaignsSmsCreateFlowV2: FC = () => {
  const history = useHistory();
  const { t } = useTranslation('campaign');
  const { t: tCommon } = useTranslation('COMMON');
  const { templatesCount, hasFetched, isLoading } = useSmsWorkspaceTemplates();

  const handleExitToList = () => {
    history.push(RouteConstants.smsCampaigns);
  };

  if (isLoading || !hasFetched) {
    return <Loading />;
  }

  if (templatesCount === 0) {
    return (
      <div className='flex flex-col items-center justify-center gap-6 rounded-2xl border border-gray-200 bg-white-100 px-6 py-20 shadow-sm'>
        <div className='max-w-xl space-y-2 text-center'>
          <h2 className='text-3xl font-semibold text-slate-900'>{t('smsWorkspace.campaigns.noTemplatesCreateTitle')}</h2>
          <p className='text-sm text-secondary-600'>{t('smsWorkspace.campaigns.noTemplatesCreateDescription')}</p>
        </div>
        <div className='flex flex-col gap-3 sm:flex-row'>
          <Button intent='secondary' onClick={handleExitToList} text={tCommon('back')} />
          <Button onClick={() => history.push(RouteConstants.createSmsTemplate)} text={t('smsWorkspace.campaigns.createDisabledBannerNoTemplatesAction')} />
        </div>
      </div>
    );
  }

  return <SmsCampaign mode='create' onExitToList={handleExitToList} />;
};
